import PropTypes from 'prop-types'

import { Colors } from '~/styles'
import { Images } from '~/assets'

import Styled from './vessel-traffic-card.styled'
import { Tooltip } from '@material-ui/core'

const VesselTrafficCard = ({ data, type }) => {
  // Determine the background color based on the vessel's color status
  const backgroundColor = data.vessel_color_status === 'Upcoming Vessel' ? Colors.lemonYellow : Colors.lightOlive
  const isOngoingVessel = type === 'ongoing_vessel'

  return (
    <Styled.Card backgroundColor={isOngoingVessel ? backgroundColor : Colors.white}>
      <Styled.CardInfoContainer>
        <Styled.CardInfoWrapper>
          <img alt='anchor-icon' src={Images.AnchorIcon} />
          <Styled.CardInfoTitle>{data.vessel_name}</Styled.CardInfoTitle>
        </Styled.CardInfoWrapper>

        <Styled.CardInfoWrapper>
          <Styled.CardInfoSubtitle>{data.sr_no}</Styled.CardInfoSubtitle>
          <Styled.CardInfoStatus backgroundColor={isOngoingVessel ? Colors.white : Colors.lightOlive}>
            {data.status}
          </Styled.CardInfoStatus>
        </Styled.CardInfoWrapper>
      </Styled.CardInfoContainer>
      <Styled.CardDetailsContainer>
        <Tooltip title={data.client}>
          <Styled.CardDetailsText>Client: <span>{data.client}</span></Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={data.all_fast}>
          <Styled.CardDetailsText>All Fast: {data.all_fast && <span>{data.all_fast}</span>}</Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={data.activity}>
          <Styled.CardDetailsText>Activity: <span>{data.activity}</span></Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={`${data.qty} ${data.uom}`}>
          <Styled.CardDetailsText>Quantity: <span>{data.qty} {data.uom}</span></Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={data.jetty}>
          <Styled.CardDetailsText>Jetty: <span>{data.jetty}</span></Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={data.cast_off}>
          <Styled.CardDetailsText>Cast Off: {data.cast_off && <span>{data.cast_off}</span>}</Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={data.product}>
          <Styled.CardDetailsText>Product: <span>{data.product}</span></Styled.CardDetailsText>
        </Tooltip>
        <Tooltip title={data.duration}>
          <Styled.CardDetailsText>Duration: {data.duration && <span>{data.duration}</span>}</Styled.CardDetailsText>
        </Tooltip>
      </Styled.CardDetailsContainer>
    </Styled.Card>
  )
}

VesselTrafficCard.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({
    qty: PropTypes.number.isRequired,
    uom: PropTypes.string.isRequired,
    sr_no: PropTypes.string.isRequired,
    jetty: PropTypes.string.isRequired,
    client: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    product: PropTypes.string.isRequired,
    all_fast: PropTypes.string,
    cast_off: PropTypes.string,
    duration: PropTypes.string,
    activity: PropTypes.string.isRequired,
    vessel_name: PropTypes.string.isRequired,
    vessel_color_status: PropTypes.string.isRequired,
  }).isRequired,
}

export default VesselTrafficCard